import { render, staticRenderFns } from "./QuestionsConductualSupport.vue?vue&type=template&id=48875274&scoped=true"
import script from "./QuestionsConductualSupport.vue?vue&type=script&lang=js"
export * from "./QuestionsConductualSupport.vue?vue&type=script&lang=js"
import style0 from "./QuestionsConductualSupport.vue?vue&type=style&index=0&id=48875274&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48875274",
  null
  
)

export default component.exports